import { PatrimonioActividad as PatrimonioActividadModel } from '../../../../../models/trust/proveedorPj/PatrimonioActividad';
import * as generic from '../../../../../components/Generico';
import { ProveedorPjService } from "../../../../../service/trust/ProveedorPjService";
import { useForm } from 'react-hook-form';
import { InputComponent } from '../../../../../components/InputComponent';
import { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Panel } from 'primereact/panel';
import { ClientePrincipal } from '../../proveedorPn/ClientePrincipal';
import { ProyectoServicio } from '../../proveedorPn/ProyectoServicio';
import { EstadoPatrimonial } from '../../../../../components/trust/EstadoPatrimonial';
import { BottomActionBar } from '../../../../../components/ui/BottomActionBar';
import { InputActividadEconomica } from '../../../../../components/ui/Formularios/InputActividadEconomica';

export const PatrimonioActividad = ({ toast, id, permss, catalogos, handlePrev, handleNext, nuevoProveedor, soloLectura }) => {

    const omodel = new PatrimonioActividadModel();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });

    const proveedorServicio = new ProveedorPjService();
    const { inText, inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (id) {
            editFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = 'seccion2';
        data.id = id;

        proveedorServicio.editarProveedor(data).then(res => {
            nuevoProveedor(res.data);
            generic.funcSuccess(res, toast);
            handleNext();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id, { seccion: 'seccion2' }).then(res => {
            const _prov = res.data.proveedor;
            if (!_prov) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="p-fluid">
            <Panel header={generic.renderPanelHeader('C', 'ESTADO PATRIMONIAL', 'pi pi-users')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 mb-4 surface-100 border-round border-1 border-300">
                    <p className="m-0 mb-2 text-700">
                        <i className="pi pi-info-circle mr-2 text-primary"></i>
                        Favor suministrarnos la siguiente información en el caso de aquellos accionistas que superen el <strong>10% en su participación</strong>.
                    </p>
                    <p className="m-0 text-600 text-sm font-italic">
                        * Se debe detallar a todos los accionistas de la compañía. Si uno de los accionistas es una persona jurídica, ya sea nacional o extranjera, se debe adjuntar una hoja que contenga el detalle de sus accionistas y así hasta llegar a la persona natural.
                    </p>
                </div>
                <div className="p-2">
                    <EstadoPatrimonial id={id} tipo="proveedorPj" toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('D', 'ACTIVIDAD ECONÓMICA', 'pi pi-briefcase')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <form id="datosActividadForm" onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid p-2">
                        <div className="col-12 mb-2">
                            <span className="text-700 font-bold text-lg border-bottom-1 border-300 pb-2 block">
                                Datos de la Actividad
                            </span>
                        </div>
                        <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />
                        {inText('sector_economico', { icon: 'pi pi-chart-bar' }, 6)}
                        {inNumber('ingreso_promedio_mensual', 2, true, { icon: 'pi pi-dollar' }, 6)}
                    </div>
                </form>

                <div className="col-12 mt-2 mb-4 border-top-1 border-300"></div>

                <div className="p-2 mb-4">
                    <span className="text-700 font-bold text-lg border-bottom-1 border-300 pb-2 block mb-3">
                        Principales Clientes
                    </span>
                    <ClientePrincipal id={id} tipo="proveedorPj" toast={toast} catalogos={catalogos} permss={permss} soloLectura={soloLectura} />
                </div>

                <div className="p-2">
                    <span className="text-700 font-bold text-lg border-bottom-1 border-300 pb-2 block mb-3">
                        Proyectos y Servicios
                    </span>
                    <ProyectoServicio id={id} tipo="proveedorPj" toast={toast} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" formId="datosActividadForm" onNext={handleNext} onPrev={handlePrev} loading={isSaving} isReadOnly={soloLectura} />
        </div>
    );
}   